module.exports = __webpack_public_path__ + "media/app/assets/specializations/death_knight/blood-0bf589a806a0e119f9978d27d8b85736.png";